<template>
    <!-- 燈箱：本人充分了解藉由網路線上服務之效力與本人親自辦理相同 -->
    <PopupBase v-model:visiblePopup="visible">
        <template #content>
            本人充分了解藉由線上服務之效力與本人親自辦理相同。
        </template>
        <template #action>
            <button
                class="btn btn-accent rounded-full"
                @click="handleClose"
            >
                取消
            </button>
            <button
                class="btn gradient-primary rounded-full"
                @click="popupConfirm"
            >
                了解並同意
            </button>
        </template>
    </PopupBase>
</template>
<script>
import { watchEffect, ref } from 'vue';
import { useRouter } from 'vue-router';
import PopupBase from '@/components/dialogs/Popup.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        PopupBase
    },
    props: {
        visiblePopup: {
            type: Boolean,
            default: false,
        },
        leaveRouteName: {
            type: String,
            default: '',
        },
    },
    emits: ['update:visiblePopup', 'handleClose'],
    setup(props, { emit }) {
        const router = useRouter();
        const visible = ref(false);
        watchEffect(() => {
            visible.value = props.visiblePopup;
        });
        const handleClose = () => {
            router.push({
                name: routeName.HOME
            });
        };
        const popupConfirm = () => {
            emit('update:visiblePopup', false);
            // emit('popupConfirm');
        };
        return {
            visible,
            handleClose,
            popupConfirm
        };
    }
};
</script>
